export const luxColors = {
    alucioPurple: {
        primary: '#4F2265',
        quaternary: '#723f8d',
        quinary: '#B9A7C1',
        secondary: '#642682',
        tertiary: '#2C0A3D',
    },
    applicationBackground: {
        primary: '#F5F2F6',
    },
    archive: {
        primary: '#2E3A59',
    },
    backgroundColor: {
        primary: '#FCFCFC',
        secondary: '#F8F8F8',
    },
    backgroundButton: {
        primary: '#EDF1F7',
    },
    basicBlack: {
        primary: '#000000',
        secondary: '#BAB5BD',
    },
    whiteText: {
        primary: '#FFFFFF',
    },
    blueText: {
        primary: '#2E3A59',
        secondary: '#0095FF',
        tertiary: '#312039',
    },
    bookMarkSelected: {
        primary: '#6FCFEE',
    },
    border: {
        primary: '#F1F1F1',
    },
    buttonBorder: {
        primary: '#EDF1F7',
        secondary: '#C5CEE0',
    },
    closeIcon: {
        primary: '#838895',
    },
    confirmationBackground: {
        primary: '#FFFFFF',
    },
    confirmationHeader: {
        primary: '#2C3651',
    },
    confirmationText: {
        primary: 'gray',
        secondary: '#6B778C',
    },
    contentPanelBackground: {
        primary: '#303030',
        secondary: '#383838',
        tertiary: '#454545',
        quaternary: '#414141',
        quinary: '#9E9E9E',
        senary: '#EAEAEA',
    },
    contentText: {
        primary: '#1A0723',
        secondary: '#D7D7D7',
        tertiary: '#3A3A3A',
        quaternary: '#B6B6B6',
    },
    delete: {
        primary: '#CB3831',
    },
    disabled: {
        primary: '#8F9BB3',
        secondary: '#E4E8F2',
        tertiary: '#C5CEE0',
        quaternary: '#F4F5F7',
        quinary: '#DFE1E6',
    },
    divider: {
        primary: '#E4E9F2',
        secondary: '#E8E6E9',
        tertiary: '#F6F5F6',
    },
    emptyStateButton: {
        primary: '#44A2DA',
    },
    emptyStateButtonText: {
        primary: '#FFFFFF',
    },
    error: {
        opacity: 1,
        primary: '#CB3831',
        secondary: '#CB3831',
    },
    flat: {
        primary: '#6D6D6D',
    },
    formFieldBorder: {
        primary: '#e4e9f2',
    },
    headerTopColor: {
        primary: '#DBDBDB',
    },
    hoveredBackground: {
        primary: '#F8F8F8',
    },
    headerTextColor: {
        primary: '#766A7B',
    },
    info: {
        opacity: 1,
        primary: '#FFFFFF',
        secondary: '#8F9BB3',
    },
    mainContainer: {
        primary: '#F5F2F6',
    },
    mediaDevice: {
        primary: '#01cc0d',
    },
    menuBackground: {
        primary: 'white',
    },
    menuBorder: {
        primary: 'white',
        secondary: '#F5F2F6',
    },
    menuShadown: {
        primary: '#000',
    },
    modalBackdrop: {
        primary: 'rgba(0, 0, 0, 0.5)',
    },
    myUnpublishedDocumentsTextColor: {
        primary: '#222B45',
    },
    opacityBackground: {
        /* 0.45 */
        darker: '#00000099',
        primary: '#00000073',
    },
    orange: {
        primary: '#FFAA00',
    },
    primary: {
        opacity: 1,
        primary: '#44A2DA',
        secondary: '#ECF6FB',
        tertiary: '#ECF2F7',
    },
    publish: {
        primary: '#35C895',
    },
    revoke: {
        primary: '#2E3A59',
    },
    rowBorder: {
        primary: '#EBECF0',
    },
    selectedRow: {
        primary: '#ECF6FB',
    },
    subtitle: {
        primary: '#838895',
        quaternary: '#717171',
        secondary: '#766A7B',
        tertiary: '#8D8391',
        quinary: '#929292',
    },
    success: {
        opacity: 1,
        primary: '#26AC8A',
        secondary: '#DFF6EE',
        tertiary: '#30AD7F',
    },
    tag: {
        opacity: 0.6,
        primary: '#FFFFFF',
        secondary: '#4f2265',
    },
    text: {
        primary: '#312039',
        secondary: '#766A7B',
    },
    thumbnailBorder: {
        primary: '#44A2DA',
        secondary: '#edf1f7',
    },
    title: {
        primary: '#75839E',
    },
    toastBackground: {
        primary: '#FFFFFF',
    },
    toastDescription: {
        primary: '#766A7B',
    },
    toastIcon: {
        information: '#44A2DA',
        success: '#35C895',
        warning: '#FFAA00',
        error: '#CB3831',
    },
    toastRemoveButton: {
        primary: '#BAB5BD',
    },
    virtual: {
        background: '#1D1D1D',
        border: '#303030',
    },
    warning: {
        opacity: 1,
        primary: '#DB8B00',
        secondary: '#FFF1D6',
        tertiary: '#F2994A',
        quaternary: '#F5A133',
        quinary: '#FEF7EF',
        senary: 'rgba(245, 161, 51, 0.08)',
    },
    watermark: {
        primary: '#FFFFFF',
    },
    watermarkBackdrop: {
        primary: 'rgba(0, 0, 0, 0.48)',
    },
};
//# sourceMappingURL=colors.js.map